module.exports = __webpack_public_path__ + "static/media/isotop_2.e570d2ca.jpeg";